/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Giveawaystats_Totalvaluetooltip3Inputs */

const id_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total nilai termasuk diskon aktif`)
};

const ms_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumlah nilai termasuk sebarang diskaun aktif`)
};

const da_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samlet værdi inklusive eventuelle aktive rabatter`)
};

const de_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtwert einschließlich aktiver Rabatte`)
};

const en_us2_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total value including any active discounts`)
};

const es_es2_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor total incluyendo cualquier descuento activo`)
};

const es_mx2_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor total incluyendo cualquier descuento activo`)
};

const fil_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kabuuang halaga kabilang ang anumang aktibong diskwento`)
};

const fr_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valeur totale incluant les réductions actives`)
};

const it_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valore totale inclusi eventuali sconti attivi`)
};

const hu_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teljes érték az aktív kedvezményekkel együtt`)
};

const nl_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totale waarde inclusief eventuele actieve kortingen`)
};

const no_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total verdi inkludert eventuelle aktive rabatter`)
};

const pl_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Łączna wartość uwzględniająca aktywne rabaty`)
};

const pt_br2_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total value including any active discounts`)
};

const pt_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor total incluindo quaisquer descontos ativos`)
};

const ro_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valoarea totală incluzând orice reduceri active`)
};

const fi_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kokonaisarvo mukaan lukien aktiiviset alennukset`)
};

const sv_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totalt värde inklusive eventuella aktiva rabatter`)
};

const vi_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng giá trị bao gồm bất kỳ giảm giá đang hoạt động nào`)
};

const tr_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktif indirimler dahil toplam değer`)
};

const cs_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Celková hodnota včetně aktivních slev`)
};

const bg_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обща стойност, включително активни отстъпки`)
};

const ru_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общая стоимость с учётом активных скидок`)
};

const uk_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загальна вартість, включаючи активні знижки`)
};

const ar_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`القيمة الإجمالية بما في ذلك أي خصومات نشطة`)
};

const hi_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सक्रिय छूट सहित कुल मूल्य`)
};

const th_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มูลค่ารวมรวมถึงส่วนลดที่กำลังใช้งานใด ๆ`)
};

const ja_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクティブな割引を含む合計価値`)
};

const zh_cn2_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total value including any active discounts`)
};

const zh_hant1_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total value including any active discounts`)
};

const ko_components_giveawaystats_totalvaluetooltip3 = /** @type {(inputs: Components_Giveawaystats_Totalvaluetooltip3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total value including any active discounts`)
};

/**
* | output |
* | --- |
* | "Total value including any active discounts" |
*
* @param {Components_Giveawaystats_Totalvaluetooltip3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_giveawaystats_totalvaluetooltip3 = /** @type {((inputs?: Components_Giveawaystats_Totalvaluetooltip3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Giveawaystats_Totalvaluetooltip3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "ms") return ms_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "da") return da_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "de") return de_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "en-US") return en_us2_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "es-ES") return es_es2_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "es-MX") return es_mx2_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "fil") return fil_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "fr") return fr_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "it") return it_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "hu") return hu_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "nl") return nl_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "no") return no_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "pl") return pl_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "pt-BR") return pt_br2_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "pt") return pt_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "ro") return ro_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "fi") return fi_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "sv") return sv_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "vi") return vi_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "tr") return tr_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "cs") return cs_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "bg") return bg_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "ru") return ru_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "uk") return uk_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "ar") return ar_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "hi") return hi_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "th") return th_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "ja") return ja_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "zh-CN") return zh_cn2_components_giveawaystats_totalvaluetooltip3(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_giveawaystats_totalvaluetooltip3(inputs)
	return ko_components_giveawaystats_totalvaluetooltip3(inputs)
});
export { components_giveawaystats_totalvaluetooltip3 as "components.giveawayStats.totalValueTooltip" }